export const SPLIT_MERCHANT_NAME = "__?!?__";

export const SEARCH_KEY = {
	MERCHANT: {
		lower: "merchant",
		upper: "Merchant",
	},
	STATUS: {
		lower: "status",
		upper: "Status",
	},
	CREATED_DATE: {
		lower: "createdDate",
		upper: "Created date",
	},
	START_DATE: {
		lower: "startDate",
    upper: "Start date",
	}
};

export const CREATE_MODAL_STEP = {
	STEP_1: "select_merchant",
	STEP_2: "select_hot_sale",
	STEP_3: "create_hot_sale",
};

export const WARNING_PRICE_LIMIT = {
	USED: 3000,
	NEW: 5000,
}